import i18n from "@/i18n";
import { normalizeLocale, FALLBACK_LOCALE } from "@/utils/allowedLocales";

export const namespaced = true;

export const state = {
  locale: normalizeLocale(FALLBACK_LOCALE)
};
export const mutations = {
  SET_LOCALE(state, lang) {
    state.locale = normalizeLocale(lang);
  }
};
export const actions = {
  setLocale({ commit, state }, lang) {
    commit("SET_LOCALE", lang);
    i18n.locale = state.locale;
  }
};
